import { Injectable } from '@angular/core';

import { ProductPaginationPort } from '../domain/ports/primary/product-pagination.port';
import { Page } from '../models/page.interface';

interface PaginatedCategory {
    pages: Page [];
    productsPage: any;
    totalPages: number;

}

@Injectable({
    providedIn: 'root',
})
export class ProductPaginationService implements ProductPaginationPort {
    private readonly pageSize: number = 12;

    private categoriesPages: Record<string, PaginatedCategory> = {};

    public productsIds: Array<{ id: number; chunk?: number }>;

    public initCategoryProducts(productsIds: number[], _categoryId): void {
        const categoryPage = {
            pages: [] as Page[],
            productsPage: {},
        } as PaginatedCategory;
        let actualPage = [];
        let pageNumber = 0;
        productsIds.forEach((id, index) => {
            const position = index + 1;
            if (position % this.pageSize === 0) {
                categoryPage.pages.push({ ids: actualPage, visited: false, position: pageNumber });
                pageNumber++;
                actualPage = [];
                actualPage.push(id);
            } else {
                actualPage.push(id);
            }
            categoryPage.productsPage[`${id}`] = categoryPage.pages.length;
        });
        if (actualPage.length > 0) {
            categoryPage.pages.push({ ids: actualPage, visited: false, position: pageNumber });
        }

        this.categoriesPages[0] = categoryPage;
    }

    public addCategoryProducts(productsIds: number[]): void {
        if (!this.categoriesPages[0]) {
            this.initCategoryProducts(productsIds, 0); return;
        }
        let actualPage = [];
        let pageNumber = this.categoriesPages[0].pages.length + 1;
        const categoryPage = this.categoriesPages[0];
        productsIds.forEach((id, index) => {
            const position = index + 1;
            if (position % this.pageSize === 0) {
                categoryPage.pages.push({ ids: actualPage, visited: false, position: pageNumber });
                pageNumber++;
                actualPage = [];
                actualPage.push(id);
            } else {
                actualPage.push(id);
            }
            categoryPage.productsPage[`${id}`] = categoryPage.pages.length;
        });
        if (actualPage.length > 0) {
            categoryPage.pages.push({ ids: actualPage, visited: false, position: pageNumber });
        }
    }

    public getPageByProduct(productId: string): Page {
        const pageIndex = this.categoriesPages[0]?.productsPage[productId];
        return this.categoriesPages[0]?.pages[pageIndex];
    }

    public markPageAsVisited(page: Page): void {
        // eslint-disable-next-line no-param-reassign
        page.visited = true;
    }
}
